interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
  className?: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass,
  className
}: Props) {
  return <div className={['mc', className].filter(Boolean).join(' ')} data-id="element-821" data-mp="1dcba1popae9k">
      <div className="ml" data-id="element-822" data-mp="1daqi87trt9fe">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-823" data-mp="1icfpdcdvh2y7">{value}</div>
      <div className="ms" data-id="element-824" data-mp="1i9tk5jegezj5">{sub}</div>
    </div>;
}